export const food = [
  { id: 1, value: "معلبات" },
  { id: 2, value: "لحوم" },
  { id: 3, value: "فواكه" },
  { id: 4, value: "تمن" },
  { id: 5, value: "زيت" },
  { id: 6, value: "دجاج" },
  { id: 7, value: "سكر" },
  { id: 8, value: "شاي" },
  { id: 9, value: "طحين" },
  { id: 10, value: "خضروات" },
  { id: 11, value: "اسماك" },
  { id: 12, value: "بقوليات" },
  { id: 13, value: "معجون طماطم" },
  { id: 14, value: "بيض" },
  { id: 15, value: "خبز" }
];
export const babyThings = [
  { id: 16, value: "حليب" },
  { id: 17, value: "حفاظات" },
  { id: 18, value: "ملابس" },
  { id: 19, value: "بودرة" },
  { id: 20, value: "العاب" }
];
export const healthThings = [
  { id: 21, value: "ادوية" },
  { id: 22, value: "معقمات" },
  { id: 23, value: "صابون" },
  { id: 24, value: "فوطة صحية " },
  { id: 53, value: "مناديل ورقية " }
];
export const clothes = [
  { id: 25, value: "رجالي" },
  { id: 26, value: "نسائي" },
  { id: 27, value: "ولادي" },
  { id: 28, value: "بناتي" },
  { id: 29, value: "احذية" }
];
export const household = [
  { id: 30, value: "كهربائيات" },
  { id: 31, value: "فراشات" },
  { id: 32, value: "بطانيات" },
  { id: 34, value: "اثاث" }
];
export const prov = [
  { id: 35, value: "أربيل", prov: "أربيل" },
  { id: 36, value: "الأنبار", prov: "الأنبار" },
  { id: 37, value: "بابل", prov: "بابل" },
  { id: 38, value: "بغداد", prov: "بغداد" },
  { id: 39, value: "البصرة", prov: "البصرة" },
  { id: 40, value: "حلبجة", prov: "حلبجة" },
  { id: 41, value: "دهوك", prov: "دهوك" },
  { id: 42, value: "القادسية", prov: "القادسية" },
  { id: 43, value: "ديالى", prov: "ديالى" },
  { id: 44, value: "ذي قار", prov: "ذي قار" },
  { id: 45, value: "السليمانية", prov: "السليمانية" },
  { id: 46, value: "صلاح الدين", prov: "صلاح الدين" },
  { id: 47, value: "كركوك", prov: "كركوك" },
  { id: 48, value: "كربلاء", prov: "كربلاء" },
  { id: 49, value: "المثنى", prov: "المثنى" },
  { id: 50, value: "ميسان", prov: "ميسان" },
  { id: 51, value: "النجف", prov: "النجف" },
  { id: 52, value: "نينوى", prov: "نينوى" },

  { id: 53, value: "واسط", prov: "واسط" }
];

